import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import validator from "validator";
import "../../styles/etapas.css";
// components
import Input from "../input/Input";

function StepThree({ nextStep, handleFormData, prevStep, values }) {
  const [error, setError] = useState(false);

  // after form submit validating the form data using validator
  const submitFormData = (e) => {
    e.preventDefault();

    // checking if value of first name and last name is empty show error else take to next step
    if (
      validator.isEmpty(values.situacao) ||
      validator.isEmpty(values.cnpj)||
      validator.isEmpty(values.razaoSocial)||
      validator.isEmpty(values.cargo)||
      validator.isEmpty(values.dtAdmissao)||
      validator.isEmpty(values.renda)||
      validator.isEmpty(values.rendaFamiliar)

    ) {
      setError(true);
    } else {
      nextStep();
    }
  };





  return (
    <>
      <div className="container">
        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body p-0">
            <div className="row">
              <div className="col-lg">
                <div className="p-5">
                  <div className="text-center">
                    <h5 className="h5 text-gray-900 mb-4">
                      CADASTRO CLIENTE <br />
                      <smal style={{ fontSize: "14px" }}>
                        Trabalhador do Comércio
                      </smal>
                    </h5>
                    <br />

                    <div className="card card-timeline px-1 border-none mb-5">
                      <ul className="bs4-order-tracking">
                        <li className="step active">
                          <div>
                            <i className="fas fa-user"></i>
                          </div>{" "}
                          <label style={{ fontSize: "10px" }}>pessoal </label>
                        </li>
                        <li className="step active">
                          <div>
                            <i className="far fa-envelope-open"></i>
                          </div>{" "}
                          <label style={{ fontSize: "10px" }}> endereço</label>
                        </li>
                        <li>
                          <div>
                            <i className="far fa-address-card"></i>
                          </div>{" "}
                          <label style={{ fontSize: "10px" }}>
                            {" "}
                            profissional{" "}
                          </label>
                        </li>
                        <li >
                          <div>
                            <i className="fas fa-file-upload"></i>
                          </div>{" "}
                          <label style={{ fontSize: "10px" }}>
                            {" "}
                            documentação{" "}
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* formulario de cadastro  */}

                  <form className="user" onSubmit={submitFormData}>
                    <div className="form-group row">
                      <div className="form-group col-sm-6">
                        <label style={{ fontSize: "10px" }}>
                          SITUAÇÃO PROFISSIONAL
                        </label>
                        <select
                          id="situacao"
                          className="form-control"
                          style={{ border: error ? "2px solid red" : "" }}
                          onChange={handleFormData("situacao")}
                          name="situacao"
                          defaultValue={values.situacao}
                        >
                          <option>Selecione</option>
                          <option value="1">Empregado</option>
                          <option value="2">Aposentado</option>
                          <option value="3">Estagiário</option>
                          <option value="4">Jovem Aprendiz</option>
                          <option value="5">Trabalhador Temporário</option>
                          <option value="6">Desempregrado</option>
                          <option value="7">Falecido</option>
                          <option value="8">Sem informação</option>
                        </select>

                        {error ? (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <hr className="mt-4" />

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label style={{ fontSize: "10px" }}>CNPJ</label>

                        <Input
                          style={{ border: error ? "2px solid red" : "" }}
                          type="text"
                          className="form-control "
                          onChange={handleFormData("cnpj")}
                          name="cnpj"
                          defaultValue={values.cnpj}
                          mask="cnpj"
                          maxlength="18"
                        />

                        {error ? (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-sm-6">
                        <label style={{ fontSize: "10px" }}>
                          RAZÃO SOCIAL(NOME DA EMPRESA)
                        </label>

                        <input
                          style={{ border: error ? "2px solid red" : "" , textTransform: "uppercase"}}
                          type="text"
                          className="form-control "
                          onChange={handleFormData("razaoSocial")}
                          name="razaoSocial"
                          defaultValue={values.razaoSocial}
                        />

                        {error ? (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label style={{ fontSize: "10px" }}>CARGO</label>

                        <input
                          type="text"
                          className="form-control "
                          style={{ border: error ? "2px solid red" : "" , textTransform: "uppercase"}}
                          onChange={handleFormData("cargo")}
                          name="cargo"
                          defaultValue={values.cargo}
                        />

                        {error ? (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label style={{ fontSize: "10px" }}>
                          DATA DE ADMISSÃO
                        </label>

                        <input
                          type="date"
                          className="form-control "
                          style={{ border: error ? "2px solid red" : "" }}
                          onChange={handleFormData("dtAdmissao")}
                          name="dtAdmissao"
                          defaultValue={values.dtAdmissao}
                        />

                        {error ? (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-sm-6">
                        <label style={{ fontSize: "10px" }}>
                          DATA DEMISSÃO
                        </label>

                        <input
                          type="date"
                          className="form-control "
                          onChange={handleFormData("dtDemissao")}
                          name="dtDemissao"
                          defaultValue={values.dtDemissao}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label style={{ fontSize: "10px" }}>RENDA</label>

                        <input
                        
                          className="form-control "
                          style={{ border: error ? "2px solid red" : "" }}
                          onChange={handleFormData("renda")}
                          name="renda"
                          defaultValue={values.renda}
                          type="number" min="0.00" max="50000.00" step="0.01"
                          
                        />

                        {error ? (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-sm-6">
                        <label style={{ fontSize: "10px" }}>
                          RENDA FAMILIAR
                        </label>

                        <input
                        
                          className="form-control "
                          style={{ border: error ? "2px solid red" : "" }}
                          onChange={handleFormData("rendaFamiliar")}
                          name="rendaFamiliar"
                          defaultValue={values.rendaFamiliar}
                          type="number" min="0.00" max="50000.00" step="0.01"
                          
                        />

                        {error ? (
                          <Form.Text style={{ color: "red" }}>
                            Este é um campo obrigatório
                          </Form.Text>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                  
                    <hr className="mt-4" />

                    <Button
                      onClick={prevStep}
                      className="btn btn-primary btn-user btn-block bg-warning"
                    >
                      Anterior
                    </Button>

                    <Button
                      type="submit"
                      className="btn btn-primary btn-user btn-block"
                    >
                      Continuar
                    </Button>
                  </form>

                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StepThree;
